import { LinearProgress, Stack, Typography } from "@mui/material";

/** Theme-aware continuation after the lightweight startup shell hands over to React. */
export default function EmbedLoading({ label = "Preparing your view…" }: { label?: string }) {
  return (
    <Stack role="status" aria-live="polite" alignItems="center" justifyContent="center" spacing={1.5} sx={{ minHeight: 180, p: 3, color: "text.secondary" }}>
      <LinearProgress
        aria-label="Loading view"
        sx={{ width: 160, maxWidth: "100%", "@media (prefers-reduced-motion: reduce)": { "& .MuiLinearProgress-bar": { animation: "none" } } }}
      />
      <Typography variant="body2">{label}</Typography>
    </Stack>
  );
}
